<div *ngIf="isLoading" class="loading-overlay">
    <div class="loading"></div>
</div>

<div class="main-container">
    <div class="conversations-container">
        <div class="conversations-header-container">
            <p class="conversations-header">Conversations:</p>
        </div>

        <div class="conversations-scroll-container">
            <button *ngFor="let conversation of conversations; let n = index;"
                [ngClass]="n === activeConversationIndex ? 'active-conversation' : 'inactive-conversation'"
                class="conversation-button"
                type="button"
                (click)="openConversation(n)"
            >
                <div class="conversation-header">
                    <p *ngIf="conversation.studentFirstName || conversation.studentLastName; else NoStudentName"
                        style="display: flex; flex-direction: row; justify-content: space-between;">
                        <span>{{conversation.studentFirstName}} {{conversation.studentLastName}}</span>
                        <span *ngIf="hasUnreadMessages(conversation) && n !== activeConversationIndex"
                            class="dot"></span>
                    </p>
                    <ng-template #NoStudentName>
                        <p style="display: flex; flex-direction: row; justify-content: space-between;">
                            <span>No Name</span>
                            <span *ngIf="hasUnreadMessages(conversation) && n !== activeConversationIndex"
                                class="dot"></span>
                        </p>
                    </ng-template>
                </div>
                <div class="conversation-details">
                    <p>Phone: {{formatPhoneNumber(undefined, conversation.phoneNumber)}}</p>
                    <p *ngIf="conversation.syStudentId">SyStudentId: {{conversation.syStudentId}}</p>
                    <p *ngIf="!conversation.syStudentId">SyStudentId:</p>
                    <p>{{conversation.timeStamp | date:'medium'}} {{conversation.direction === INBOUND ? 'Inbound' :
                        'Outbound'}}</p>
                </div>
            </button>
        </div>

    <div class="version-text">
    Version: {{ version }}
    </div>
    </div>

    <div class="msg-and-response-outer-container">
        <div class="msg-and-response-top-container">
            <button class="student-search-button" (click)="showSearchDialog()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" width="18px"
                    height="18px">
                    <path
                        d="M15.7574 14.7187L11.5687 10.5312C12.4752 9.42187 12.9754 8.025 12.9754 6.5C12.9754 2.90937 10.0643 0 6.47362 0C2.88297 0 0 2.91031 0 6.5C0 10.0897 2.91079 13 6.47362 13C7.99871 13 9.39784 12.4716 10.506 11.5925L14.6946 15.78C14.8696 15.9281 15.0634 16 15.2541 16C15.4448 16 15.638 15.9267 15.7846 15.7803C16.0762 15.4875 16.0762 15.0125 15.7574 14.7187ZM1.50041 6.5C1.50041 3.74312 3.74414 1.5 6.50175 1.5C9.25937 1.5 11.5031 3.74312 11.5031 6.5C11.5031 9.25687 9.25937 11.5 6.50175 11.5C3.74414 11.5 1.50041 9.25625 1.50041 6.5Z">
                    </path>
                </svg>
            </button>

            <div class="msg-and-response-header">
                <span style="font-weight: 700;">{{activeStudent.firstName}} {{activeStudent.lastName}}</span>
                <span *ngIf="activeStudent.syStudentId">&nbsp;&nbsp;[{{activeStudent.syStudentId}}]</span>
                <span *ngIf="activeStudent.phone">&nbsp;&nbsp;{{formatPhoneNumber(activeStudent.phone)}}</span>
                &nbsp;
            </div>

            <div *ngIf="activeStudent.syStudentId && iDashUrl" class="idash-container">
                <a href="{{iDashUrl}}" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/img/idash-logo.png" height="40" alt="iDash Logo" />
                </a>
            </div>
        </div>

        <div class="toolbar-container">
            <div class="toolbar-primary">
                <button *ngIf="activeConversationId" class="toolbar-button" (click)="disconnectButtonPressed()">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" width="20px"
                        height="20px">
                        <path
                            d="M0.750117 11.902C1.16018 11.902 1.50023 11.6045 1.50023 11.2457V5.93358L4.4807 8.06892C4.62072 8.16518 4.79075 8.21769 4.95077 8.21769C5.17081 8.21769 5.38084 8.13893 5.53086 7.97265C5.80091 7.69261 5.7609 7.28129 5.44085 7.05376L1.71027 4.38459C1.58025 4.28833 1.50023 4.1483 1.50023 3.99953V3.62322C1.50023 3.37818 1.72027 3.18565 2.00031 3.18565H10.7117C11.1217 3.18565 11.4618 2.88811 11.4618 2.5293C11.4618 2.1705 11.1317 1.87295 10.7117 1.87295H2.00031C0.900141 1.87295 0 2.66057 0 3.62322V11.2457C0 11.6045 0.340053 11.902 0.750117 11.902Z">
                        </path>
                        <path
                            d="M15.7825 2.11799C16.0725 1.8642 16.0725 1.44413 15.7825 1.19034C15.4924 0.936553 15.0123 0.936553 14.7223 1.19034L0.220034 13.8798C-0.0700109 14.1336 -0.0700109 14.5537 0.220034 14.8075C0.370058 14.93 0.560088 15 0.750117 15C0.940147 15 1.13018 14.9387 1.2802 14.8075L2.06032 14.1249H13.9922C15.0924 14.1249 15.9925 13.3372 15.9925 12.3746V7.37756C15.9925 7.01875 15.6524 6.72121 15.2424 6.72121C14.8323 6.72121 14.4923 7.01875 14.4923 7.37756V12.3746C14.4923 12.6196 14.2722 12.8122 13.9922 12.8122H3.56056L7.18112 9.64416C7.45116 9.71417 7.73121 9.74918 8.00125 9.74918C8.73136 9.74918 9.46148 9.5304 10.0516 9.10158L15.2324 5.391C15.7125 5.0497 15.9925 4.53336 15.9925 3.99078V3.62322C15.9925 3.1594 15.7825 2.73933 15.4324 2.41553L15.7825 2.11799ZM14.4923 3.62322V3.99953C14.4923 4.1483 14.4123 4.28833 14.2822 4.38459L9.11142 8.09517C8.9914 8.18268 8.86138 8.2527 8.72136 8.3052L14.3822 3.35193C14.4523 3.42194 14.4923 3.51821 14.4923 3.62322Z">

                        </path>
                    </svg>

                </button>
                <div *ngIf="activeStudentCapStatistics.unrespondedCountIndividual !== undefined"
                    class="toolbar-cap-container">
                    <span class="toolbar-cap-header">
                        Caps:
                    </span>
                    <span class="toolbar-cap-item">
                        Individual:
                        {{activeStudentCapStatistics.unrespondedCountIndividual}}/{{activeStudentCapStatistics.individualUnrespondedCap}}
                    </span>
                    <span class="toolbar-cap-item">
                        Workgroup:
                        {{activeStudentCapStatistics.unrespondedCountWorkgroup}}/{{activeStudentCapStatistics.workgroupUnrespondedCap}}
                    </span>
                    <span class="toolbar-cap-item">
                        Company:
                        {{activeStudentCapStatistics.unrespondedCountCompany}}/{{activeStudentCapStatistics.companyUnrespondedCap}}
                    </span>
                    <span class="toolbar-cap-item">
                        Will be lifted: {{activeStudentCapStatistics.capLiftedDateTime | date:'short'}}
                    </span>
                </div>
            </div>

            <div class="toolbar-secondary">
                <button class="toolbar-button" [ngClass]="{'active-button' : activeToolbarButton === ATB.filter}"
                    (click)="toolbarButtonClicked(ATB.filter)" [disabled]="messages.length === 0">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" width="20px"
                        height="20px">
                        <path
                            d="M0 2.38448C0 1.67508 0.583437 1.09998 1.30312 1.09998H14.6969C15.4156 1.09998 16 1.67508 16 2.38448C16 2.6802 15.8969 2.96667 15.7062 3.19462L10.5 9.49395V13.905C10.5 14.4533 10.0469 14.9 9.49063 14.9C9.2625 14.9 9.04062 14.823 8.8625 14.6566L5.97187 12.4234C5.675 12.1893 5.5 11.835 5.5 11.4592V9.49395L0.292906 3.19462C0.103469 2.96667 0 2.6802 0 2.38448ZM1.7175 2.57855L6.83125 8.7639C6.94062 8.89636 7 9.0627 7 9.23212V11.3391L9 12.9039V9.23212C9 9.0627 9.05937 8.89636 9.16875 8.7639L14.2812 2.57855H1.7175Z">
                        </path>
                    </svg>
                </button>

                <button class="toolbar-button" [ngClass]="{'active-button' : activeToolbarButton === ATB.script}"
                    (click)="toolbarButtonClicked(ATB.script)" disabled>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" width="20px"
                        height="20px">
                        <path
                            d="M14.6667 9.5H13.3333V3.5C13.3333 2.12156 12.3361 1 11.1111 1H2.22222C0.996944 1 0 2.12156 0 3.5V5C0 5.82844 0.596944 6.5 1.33333 6.5H2.22222V5H1.33333V3.5C1.33333 2.94937 1.73278 2.5 2.22222 2.5C2.71167 2.5 3.11111 2.94937 3.11111 3.5V12.5C3.11111 13.8781 4.10833 15 5.33333 15H12.7389C14.5361 15 16 13.3531 16 11.3313V11C16 10.1719 15.4028 9.5 14.6667 9.5ZM6.22222 10.5V12.5C6.22222 13.0506 5.82278 13.5 5.33333 13.5C4.84389 13.5 4.44444 13.0506 4.44444 12.5V3.5C4.44444 3.14406 4.37575 2.80687 4.25608 2.5H11.1111C11.6 2.5 12 2.95 12 3.5V9.5H7.11111C6.61944 9.5 6.22222 9.94687 6.22222 10.5ZM14.6667 11.3313C14.6667 12.5281 13.8028 13.5 12.7389 13.5H7.36667C7.48611 13.1937 7.55556 12.8562 7.55556 12.5V11H14.6667V11.3313Z">
                        </path>
                    </svg>
                </button>

                <button class="toolbar-button" [ngClass]="{'active-button' : activeToolbarButton === ATB.journey}"
                    (click)="toolbarButtonClicked(ATB.journey)" hidden>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" width="20px"
                        height="20px">
                        <path
                            d="M11.3333 3.72437C11.3333 4.02105 11.2833 4.32397 11.1694 4.64563C11.0361 5.19213 10.7611 5.86043 10.4333 6.49438L10.4306 6.47252C10.3444 6.66614 10.2556 6.83477 10.1639 7.00029C10.0417 7.21889 9.91389 7.40939 9.78889 7.64985L9.77778 7.66859C9.275 8.50865 8.75833 9.26126 8.41111 9.72033C8.19722 10.0482 7.80278 10.0482 7.58889 9.72033C7.24167 9.26126 6.725 8.50865 6.22222 7.66859C5.71111 6.81604 5.21389 5.87292 4.925 5.02974C4.90278 4.96416 4.88056 4.89858 4.83611 4.833C4.73889 4.43951 4.66667 4.07414 4.66667 3.75248C4.66667 3.6057 4.675 3.46205 4.68889 3.32152C4.87778 1.45528 6.28889 0.00500488 8 0.00500488C9.84167 0.00500488 11.3333 1.68294 11.3333 3.75248V3.72437ZM8 4.7237C8.61389 4.7237 9.11111 4.19281 9.11111 3.47454C9.11111 2.8128 8.61389 2.22538 8 2.22538C7.38611 2.22538 6.88889 2.8128 6.88889 3.47454C6.88889 4.19281 7.38611 4.7237 8 4.7237ZM9.77778 9.39243C10.1528 8.82406 10.5778 8.14639 10.9639 7.44374C11.0139 7.35318 11.0611 7.26261 11.1111 7.17205V14.1736L14.6667 12.7214V4.82363L11.6472 6.05717C11.7083 5.9104 11.7667 5.76674 11.8222 5.61997C11.9861 5.18276 12.1278 4.71121 12.1889 4.23965L15.1056 3.04795C15.3111 2.96457 15.5389 2.9983 15.7167 3.13727C15.8944 3.2778 16 3.50889 16 3.72437V13.2461C16 13.5615 15.825 13.8425 15.5611 13.9519L10.6722 15.9505C10.525 16.0098 10.3639 16.0098 10.2167 15.9505L5.55556 14.0424L0.894444 15.9505C0.69 16.0317 0.462222 16.0005 0.284167 15.8599C0.106083 15.7194 0 15.4883 0 15.2447V5.72302C0 5.43572 0.175389 5.15466 0.438889 5.04536L3.77778 3.68065C3.77778 3.70563 3.77778 3.72749 3.77778 3.72437C3.77778 4.22404 3.88056 4.71121 4.025 5.17652L1.33333 6.27578V14.1736L4.88889 12.7214V7.17205C4.93889 7.26261 4.98611 7.35318 5.03611 7.44374C5.42222 8.14639 5.84722 8.82406 6.22222 9.39243V12.7214L9.77778 14.1736V9.39243Z">
                        </path>
                    </svg>
                </button>

                <button class="toolbar-button" [ngClass]="{'active-button' : activeToolbarButton === ATB.responses}"
                    (click)="toolbarButtonClicked(ATB.responses)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true" width="20px"
                        height="20px">
                        <path
                            d="M2.21 19.48v.33a6.62 6.62 0 106.62-6.62 7.8 7.8 0 00-2.26.39 11.86 11.86 0 013.36-5.14A1.65 1.65 0 0010 6.12a1.77 1.77 0 00-1.21-.55A1.76 1.76 0 007.72 6c-5.57 5.09-5.51 13.09-5.51 13.42v.06z">
                        </path>
                        <path
                            d="M23.17 26.43a6.62 6.62 0 000-13.24 7.8 7.8 0 00-2.26.39 12.94 12.94 0 013.37-5.13 1.65 1.65 0 00.11-2.32A1.61 1.61 0 0022.07 6c-5.57 5.08-5.52 13.08-5.52 13.41v.39a6.64 6.64 0 006.62 6.62z">
                        </path>
                    </svg>
                </button>

                <button class="toolbar-button" [ngClass]="{'active-button' : activeToolbarButton === ATB.notes}"
                    (click)="toolbarButtonClicked(ATB.notes)" hidden>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" width="20px"
                        height="20px">
                        <path
                            d="M10.625 7H5.375C4.89375 7 4.5 7.3375 4.5 7.75C4.5 8.1625 4.89375 8.5 5.375 8.5H10.625C11.1099 8.5 11.5 8.16563 11.5 7.75C11.5 7.33437 11.1099 7 10.625 7ZM7.125 10H5.375C4.89375 10 4.5 10.3375 4.5 10.75C4.5 11.1625 4.89193 11.5 5.375 11.5H7.125C7.60807 11.5 8 11.1641 8 10.75C8 10.3359 7.6099 10 7.125 10ZM10.625 4H5.375C4.89375 4 4.5 4.3375 4.5 4.75C4.5 5.1625 4.89375 5.5 5.375 5.5H10.625C11.1099 5.5 11.5 5.16563 11.5 4.75C11.5 4.33437 11.1099 4 10.625 4ZM12.6667 0H3.33333C2.04453 0 1 0.895313 1 2V14C1 15.1047 2.04453 16 3.33333 16H12.6667C13.9555 16 15 15.1047 15 14V2C15 0.895313 13.9536 0 12.6667 0ZM13.25 14C13.25 14.2757 12.9883 14.5 12.6667 14.5H3.33333C3.0117 14.5 2.75 14.2757 2.75 14V2C2.75 1.72431 3.0117 1.5 3.33333 1.5H12.6667C12.9883 1.5 13.25 1.72431 13.25 2V14Z">
                        </path>
                    </svg>
                </button>

                <button class="toolbar-button" [ngClass]="{'active-button' : activeToolbarButton === ATB.wrapup}"
                    (click)="toolbarButtonClicked(ATB.wrapup)" disabled>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" width="20px"
                        height="20px">
                        <path
                            d="M9.65938 7.2875L7.39375 10.1719L6.2375 9.18125C5.92188 8.9125 5.45 8.94687 5.18125 9.2625C4.91172 9.57687 4.94784 10.0506 5.26231 10.32L7.01231 11.82C7.15 11.9094 7.32188 12 7.5 12C7.52442 12 7.54881 11.999 7.57325 11.9961C7.77687 11.9766 7.96325 11.874 8.08981 11.7129L10.8398 8.21291C11.0957 7.88759 11.039 7.41603 10.7133 7.16009C10.3875 6.87813 9.91563 6.9625 9.65938 7.2875ZM12 2H10.4497C10.1906 0.85875 9.20938 0 8 0C6.79062 0 5.78125 0.85875 5.55 2H4C2.89531 2 2 2.89562 2 4V14C2 15.1044 2.89531 16 4 16H12C13.1047 16 14 15.1044 14 14V4C14 2.89562 13.1031 2 12 2ZM8 1.5C8.41344 1.5 8.75 1.83656 8.75 2.25C8.75 2.66344 8.4125 3 8 3C7.5875 3 7.25 2.66344 7.25 2.25C7.25 1.83656 7.5875 1.5 8 1.5ZM12.5 14C12.5 14.2756 12.2757 14.5 12 14.5H4C3.72431 14.5 3.5 14.2756 3.5 14V4C3.5 3.72438 3.72431 3.5 4 3.5H4.57063C4.52906 3.65937 4.5 3.825 4.5 4V4.5C4.5 4.775 4.72375 5 5 5H11C11.2761 5 11.5 4.77613 11.5 4.5V4C11.5 3.82628 11.4709 3.66062 11.4292 3.5H12C12.2757 3.5 12.5 3.72438 12.5 4V14Z">
                        </path>
                    </svg>
                </button>
            </div>
        </div>

        <div class="msg-and-response-container">
            <div class="msg-and-input-container">
                <div id="MessageContainer" class="msg-container">
                    <div class="msg-top-bar">
                        <span class="top-bar">This is the beginning of the conversation.</span>
                    </div>

                    <div *ngFor="let msg of filteredMessages; let n = index;"
                        [ngClass]="msg.direction === INBOUND ? 'customer-msg' : 'agent-msg'" [id]="getMsgID(n)">
                        <div class="msg-and-avatar">
                            <div class="msg-avatar">
                                <i class="bi bi-person-circle" style="font-size: 2rem; color: #b8b8b8;"></i>
                            </div>
                            <div class="msg-tail"> </div>
                            <div class="msg-and-timestamp">
                                <div class="msg">
                                    <p class="msg-content">{{msg.smsText}}</p>
                                </div>
                                <div class="msg-timestamp">
                                    <p>
                                        {{msg.timeStamp | date:'medium'}}
                                    </p>
                                    <p *ngIf="msg.outboundStatus" class="msg-error">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" aria-hidden="true"
                                            width="12px" height="12px" style="fill: #D2322D;">
                                            <path
                                                d="M15.8215 13.387L9.16094 1.20766C8.90488 0.739224 8.45522 0.505005 8.00556 0.505005C7.5559 0.505005 7.10625 0.739224 6.82209 1.20766L0.164643 13.387C-0.319052 14.3206 0.319245 15.495 1.34625 15.495H14.6674C15.6904 15.495 16.3305 14.3239 15.8215 13.387ZM1.65351 13.8889L7.97746 2.27168L14.357 13.8889H1.65351ZM8.00556 10.7136C7.46348 10.7136 7.02381 11.1847 7.02381 11.7656C7.02381 12.3464 7.46441 12.8175 8.00681 12.8175C8.54921 12.8175 8.98732 12.3464 8.98732 11.7656C8.98607 11.1854 8.5489 10.7136 8.00556 10.7136ZM7.25613 5.5909V8.80304C7.25613 9.24806 7.59338 9.60608 8.00556 9.60608C8.41775 9.60608 8.75499 9.24638 8.75499 8.80304V5.5909C8.75499 5.14923 8.42087 4.78786 8.00556 4.78786C7.59025 4.78786 7.25613 5.14923 7.25613 5.5909Z">
                                            </path>
                                        </svg>
                                        {{msg.outboundStatus}}
                                    </p>
                                    <p *ngIf="msg.direction === OUTBOUND">{{msg.agentName}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-input-container">
                    <button type="button" class="scroll-button" (click)="scrollToLatestMessage()"
                        [ngClass]="atLastMessage ? 'hide' : ''">
                        Scroll to latest
                    </button>

                    <div class="input-group">
                        <textarea #msgTextBox rows="2" placeholder="{{messageBoxPlaceholder}}" class="text-input"
                            [(ngModel)]="msgText" [disabled]="!allowedToSend || cannedMessagesOnly">
                        </textarea>

                        <button class="send-button" (click)="sendButtonPressed()"
                            [disabled]="!allowedToSend">Send</button>
                    </div>
                </div>
            </div>

            <div class="tool-container">
                <ng-container class="tool-container"
                    *ngComponentOutlet="toolboxItems[selectedToolIndex].component; inputs: toolboxItems[selectedToolIndex].inputs;" />
            </div>


        </div>
    </div>

    <dialog #searchDialog id="searchDialog" class="modal-search-dialog">
        <div class="dialog-container">
            <div *ngIf="isLoading" class="loading-overlay">
                <div class="loading"></div>
            </div>

            <div class="dialog-header">
                <div class="dialog-close-button-container">
                    <button class="dialog-close-button" (click)="searchDialog.close()">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" width="20px"
                            height="20px">
                            <path
                                d="M12.7494 11.7231C13.0419 12.0151 13.0419 12.4889 12.7494 12.781C12.4569 13.073 11.9823 13.073 11.6897 12.781L8.00051 9.07065L4.2851 12.7797C3.99258 13.0717 3.51797 13.0717 3.22542 12.7797C2.93287 12.4877 2.93291 12.0139 3.22542 11.7219L6.94209 8.01403L3.22439 4.27689C2.93188 3.98487 2.93188 3.51108 3.22439 3.21903C3.51691 2.92698 3.99152 2.92701 4.28407 3.21903L8.00051 6.95741L11.7159 3.24833C12.0084 2.95631 12.4831 2.95631 12.7756 3.24833C13.0682 3.54035 13.0681 4.01414 12.7756 4.30619L9.05894 8.01403L12.7494 11.7231Z">
                            </path>
                        </svg>
                    </button>
                </div>
            </div>

            <div class="dialog-content">
                <div class="dialog-title">
                    Student Search
                </div>

                <div class="student-search-container">
                    <div class="student-search-type">
                        <label><input type="radio" [(ngModel)]="searchType" name="searchType" value="SyStudentId" (change)="onSearchTypeChange()">
                            SyStudentId</label>
                        <label><input type="radio" [(ngModel)]="searchType" name="searchType" value="Phone Number" (change)="onSearchTypeChange()">
                            Phone Number</label>
                    </div>

                    <div class="student-search-inner-container">
                        <div class="student-search-input-container">
                            <div class="student-search">
                                <input id="searchInputBox" (keypress)="validateSearchInputKeys($event)"
                                (input)="validateSearchInput()"
                                    [(ngModel)]="searchValue" placeholder=" Enter {{searchType}}"
                                    class="student-search-input" (paste)="onPaste($event)">
                            </div>
                        </div>

                        <button [disabled]="!enableSearch" (click)="performStudentSearch()">Search</button>
                    </div>


                    <div class="search-results-container">
                        <div *ngIf="searchErrorMessage" class="search-error">
                            {{searchErrorMessage}}
                        </div>
                        <a *ngFor="let student of searchResults; let n = index" class="student-search-results"
                            [ngClass]="getSearchResultsClass(student)"
                            href="javascript:void(0)"
                            (click)="searchItemSelected(n)"
                        >
                            <div class="conversation-header">
                                <p>{{student.firstName}} {{student.lastName}}</p>
                            </div>
                            <div class="conversation-details">
                                <p>SyStudentId: {{student.syStudentId}}</p>
                                <p>{{student.schoolStatus}}</p>
                                <p>{{student.campus}}</p>
                                <p>Phone: {{formatPhoneNumber(student.phone)}}</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </dialog>
</div>
